import React from 'react';
// Consntants
import { CompanyName } from '../../utils/Constants';
// Icons
import { BsArrowDownCircle } from 'react-icons/bs';
// Images
import MainImage1 from '../../assets/images/domination/mistress-maria-norfolk-dominatrix-pro-domme-dungeon-picture-xbytas.webp';
// Components
import Navbar from '../../components/nav/Navbar';
import FooterComponent from '../../components/footer/FooterComponent';
import HomePageMainContainer from '../../components/home/HomePageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import {
  homePageAdditionalMeta,
  homePageStructuredData,
} from '../../utils/data/MetaData';

const HomePage = React.memo(() => {
  return (
    <>
      {/* SEO / head tags */}
      <HelmetItem
        PageName='Home'
        desc={`Enter the refined world of ${CompanyName}. Norfolk-based Dominatrix offering tailored sessions: sissy & maid training, ABDL nursery roleplay, corporal punishment, bondage & restraint, and virtual control.`}
        keywords={`Mistress Maria, Dominatrix Norfolk, Femdom UK, sissy training, ABDL nursery, corporal punishment, bondage, BDSM roleplay, fly me to you`}
        additionalMeta={homePageAdditionalMeta}
        structuredData={homePageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins invisible_scrollbar'>
        <div className='grid min-h-screen max-h-screen h-screen overflow-hidden'>
          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <div className='fixed w-full h-full'>
            <header className='grid relative h-full w-full bg-center bg-no-repeat bg-cover'>
              {/* White overlay */}
              <div className='absolute top-0 left-0 w-full h-full bg-colour1/50 z-10'></div>

              <div className='grid absolute top-0 left-0 h-full w-full lg:left-1/2'>
                <img
                  src={MainImage1}
                  alt='Hero background illustrating the atmosphere of sessions'
                  className='h-full w-full object-cover lg:w-fit'
                  fetchpriority='high' // improves LCP per Lighthouse
                  decoding='async'
                />
              </div>

              {/* Text */}
              <article className='grid w-full h-full justify-center items-center z-10'>
                <div className='grid gap-y-4 h-fit text-center'>
                  <section>
                    <div>
                      <h2 className='text-sm lg:text-2xl uppercase text-colour6 -mb-1 text_shadow'>
                        Welcome to my world
                      </h2>
                    </div>
                    <div>
                      <h1 className='text-[2.5rem] lg:text-8xl font-titleFont py-2 text_shadow'>
                        {CompanyName}
                      </h1>
                    </div>
                    <div>
                      <h3 className='-mt-1 text-base lg:text-xl text_shadow'>
                        Embrace my various sides: Mistress, Nanny,
                        Disciplinarian, Role Player, and Event Organiser
                      </h3>
                    </div>
                    <div>
                      <p className='font-titleFont text-colour6 text-4xl pt-4 text_shadow'>
                        Ms Maria @ AB-Nursery
                      </p>
                    </div>
                  </section>
                  <a
                    href='#home-page-main'
                    className='flex justify-center text-3xl'
                    aria-label='Skip to main content'
                    title='Skip to main content'
                  >
                    <BsArrowDownCircle aria-hidden='true' />
                  </a>
                </div>
              </article>
            </header>
          </div>
        </div>

        {/* Main content */}
        <HomePageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
});

export default HomePage;
